import Vue from 'vue'
import VueRouter from 'vue-router'
import aboutPage from '../views/aboutPage.vue'
import privacy from '../views/privacyPage.vue'
import ourHelp from '../views/ourHelp.vue'
import ourSecurity from '../views/ourSecurity‌.vue'
import Index from '../views/homepage/indexPage.vue'
import homePage3 from '../views/homepage/homePage3.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/homePage3',
    name: 'homePage3',
    component: homePage3
  },
  {
    path: '/aboutPage',
    name: 'aboutPage',
    component: aboutPage
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: privacy
  },
  {
    path: '/ourHelp',
    name: 'ourHelp',
    component: ourHelp
  },
  {
    path: '/ourSecurity',
    name: 'ourSecurity',
    component: ourSecurity
  }
  // 可以继续添加更多路由
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth',
        offset: { x: 0, y: 84 } // 5.25rem = 84px，为固定导航栏留出空间
      }
    }
    return { x: 0, y: 0, behavior: 'smooth' }
  }
})

export default router